export default __webpack_public_path__ + "static/pocket-logo-9a692915d9c09a90d452f1a01c2cb636.svg";